import { render, staticRenderFns } from "./CategoryDrawer.vue?vue&type=template&id=0c1f0e8d&"
import script from "./CategoryDrawer.vue?vue&type=script&lang=js&"
export * from "./CategoryDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports